<script setup lang="ts">
// Authenticated member sidebar — role-filtered nav (doc 04 §9.2).
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth.store'
import type { RoleName } from '@/types/enums'

interface NavItem {
  title: string
  icon: string
  to: string
  roles?: RoleName[]
}

const auth = useAuthStore()
const { roles } = storeToRefs(auth)

const nav: NavItem[] = [
  { title: 'Dashboard', icon: 'mdi-view-dashboard', to: '/app/dashboard' },
  { title: 'My Bookings', icon: 'mdi-calendar-check', to: '/bookings' },
  {
    title: 'Admin',
    icon: 'mdi-shield-crown',
    to: '/admin',
    roles: ['super-admin', 'association-admin'],
  },
]

const visible = computed(() =>
  nav.filter((item) => !item.roles || auth.hasAnyRole(item.roles)),
)
// Touch `roles` so the computed re-evaluates when the role set changes.
void roles
</script>

<template>
  <v-navigation-drawer color="surface" permanent>
    <v-list nav>
      <v-list-item
        v-for="item in visible"
        :key="item.to"
        :to="item.to"
        :prepend-icon="item.icon"
        :title="item.title"
      />
    </v-list>
  </v-navigation-drawer>
</template>
